import React from 'react';
import { isServer } from '@app/utils';

import useLoadSegment from './hooks/useLoadSegment';
import client from '../../client';
import SegmentContext from '../../state/SegmentContext';

/**
 *
 * @param children
 * @constructor
 */
const SegmentProvider = ({ children }) => {
  useLoadSegment();

  return (
    <SegmentContext.Provider value={isServer ? undefined : client}>
      {children}
    </SegmentContext.Provider>
  );
};

export default SegmentProvider;
